import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

import type {
    GetAppDefinitionCatalog,
    GetAppDefinition,
    GetAppDefinition_sync,
} from './platformAppDefinitionQueries';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AppDefinitions" */ './lazyIndex'),
    { name: 'AppDefinitions' }
);

export const lazyGetAppDefinition: LazyAction<
    typeof lazyIndex.getAppDefinition,
    typeof lazyModule
> = new LazyAction<GetAppDefinition, typeof lazyModule>(lazyModule, m => m.getAppDefinition);

export const lazyGetAppDefinition_sync: LazyAction<
    typeof lazyIndex.getAppDefinition_sync,
    typeof lazyModule
> = new LazyAction<GetAppDefinition_sync, typeof lazyModule>(
    lazyModule,
    m => m.getAppDefinition_sync
);

export const lazyGetAppDefinitionCatalog: LazyAction<
    typeof lazyIndex.getAppDefinitionCatalog,
    typeof lazyModule
> = new LazyAction<GetAppDefinitionCatalog, typeof lazyModule>(
    lazyModule,
    m => m.getAppDefinitionCatalog
);
